<template>
    <v-dialog v-model="show" :content-class="''" :max-width="'600px'">
        <v-card class="pa-8" color="#52b8d3">
            <v-icon size="32" class="position-absolute right-0 top-0" @click="show = false">
                mdi-window-close
            </v-icon>
            <v-row justify="center">
                <v-col cols="12" md="6" class="pr-0">
                    <v-responsive content-class="text-center d-flex justify-content-center">
                        <v-img src="https://d1g4amnkr5x29r.cloudfront.net/assets/images/device4.png" max-width="200">
    
                        </v-img>
                    </v-responsive>
                </v-col>
                <v-col cols="12" md="6" class="pl-0 d-flex flex-column justify-between" style="">
                    <div class="hint-text" style="flex-grow: 1; display: flex; align-items: center; justify-content: center; padding: 16px;">
                        {{$t('shop.follow-modal.label')}}
                    </div>
                    <div class="d-flex justify-center" style="padding-bottom: 16px;">
                        <a target="_blank" href="https://appsto.re/de/Ibzr6.i">
                            <img class="clickable"  src="https://d1g4amnkr5x29r.cloudfront.net/assets/images/AppStore.png" alt="" style="height:40px; margin-right: 8px;">
                        </a>
                        <a target="_blank" href="https://play.google.com/store/apps/details?id=de.findeling.findeling">
                            <img class="clickable" src="https://d1g4amnkr5x29r.cloudfront.net/assets/images/playstore.png" alt="" style="height:40px;">
                        </a>
                    </div>
                </v-col>
            </v-row>
        </v-card>
    </v-dialog>
</template>

<script>
import { ref } from 'vue';

export default {
    props: {
        modelValue: {
            type: Boolean,
            required: true,
        },
    },
    computed: {
        show: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit("update:modelValue", value);
            },
        },
    },
    setup() {

        return {
        };
    },
};
</script>
<style scoped>
.hint-text{
    vertical-align: middle;
    display: inline-block;
    color: #fff;
    font-size: 1.5em;
    text-align: left;
}
</style>
